exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-btn[data-v-04f7e585] {\n  margin-right: 16px;\n}\n.smaller-button[data-v-04f7e585] {\n  width: 30px;\n  /* Adjust width */\n  height: 30px;\n  /* Adjust height */\n  min-width: 30px;\n  padding: 4px;\n  font-size: 12px;\n  margin: 0;\n}\n", ""]);

// exports
